import {useState} from 'react';
import {SVG} from '../../../../../../../constants/assetLists';
import {downloadUsersTemplate} from './components/AddUsers';

const USERS_INFO = [
  {
    name: 'פרטים שכדאי להכין מראש',
    desc: 'שם משתמש, אימייל, מספר טלפון, לאיזה מקומות משוייך',
  },
  {
    name: 'משתמש שעובד בסניף אחד',
    desc: 'בפתיחת כרטיס משתמש אוטומטית המשתמש ישויך לסניף ',
  },
  {
    name: 'משתמש שעובד בכמה סניפים',
    desc: 'ניתן לבחור למשתמש מספר סניפים ולשייך אותו אליהם. כך יוכל לעבוד בכמה סניפים.',
  },
];

const UsersHeader = () => {
  const [showUsersDetails, setShowUsersDetails] = useState(false);

  const toggleUsersDetails = (opt: boolean) => {
    setShowUsersDetails(opt);
  };

  return (
    <>
      <div className="pb-2">
        <div className="flex justify-between items-end flex-wrap gap-2">
          <div className="flex flex-col">
            <p className="m-0 text-xl text-deepAqua font-bold">הגדרת משתמשים</p>

            <p className="m-0 mt-2 text-base text-darkerGray">
              הוסיפו משתמשים, ותנו להם תפקידים. תוכלו לעשות זאת במועד מאוחר
              יותר. <br /> באפשרותכם להשתמש בתבנית האקסל לאסוף את המשתמשים לתוכה
              ולהעלות אותם בבת אחת.
            </p>
          </div>
          <div>
            <button
              className="py-1 px-3 bg-transparent rounded-full flex items-center gap-2 border-1"
              onClick={downloadUsersTemplate}>
              <img
                src={SVG.excelGreenIcon}
                alt="info"
                className="w-5 h-5 object-contain"
              />
              <p className="m-0 text-base">
                הורידו תבנית אקסל להעלאת משתמשים בבת אחת
              </p>
            </button>
          </div>
          <div className="">
            <div className="flex justify-end">
              <button
                className="py-1 px-2 bg-icyBlue rounded-md flex items-center gap-2"
                onClick={() => toggleUsersDetails(true)}>
                <img
                  src={SVG.infoBlueIcon}
                  alt="info"
                  className="w-5 h-5 object-contain"
                />
                <p className="m-0 text-base text-tealBlue underline">
                  מה המערכת מאפשרת למשתמשים מהסוגים השונים
                </p>
              </button>
            </div>
          </div>
        </div>

        <div className="mt-2">
          {showUsersDetails && (
            <div className="px-4 py-1 border border-[#E9FAFF] bg-[#F0FCFF] rounded-tr-md rounded-br-md rounded-bl-md shadow-md relative">
              {USERS_INFO.map((user, idx) => (
                <div
                  key={idx}
                  className={`py-1 flex items-center gap-2 border-b border-gray70 ${idx === USERS_INFO.length - 1 ? 'border-b-0' : ''}`}>
                  <div className="">
                    <p className="m-0 text-base font-bold text-darkBlue">
                      {user.name}
                    </p>
                  </div>

                  <p className="m-0 text-base text-black">{user.desc}</p>
                </div>
              ))}

              <button
                className="absolute top-1 left-2 w-6 h-6 flex justify-center items-center pr-3"
                onClick={() => toggleUsersDetails(false)}>
                <img
                  src={SVG.closeDarkIcon}
                  className="w-[11px] h-[11px] object-contain"
                />
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default UsersHeader;
